import {GetSolusPortal, GetSolusPortalModel} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetSolusPortal implements GetSolusPortal {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetSolusPortalModel>,
	) {}

	async get(): Promise<GetSolusPortalModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
